export const TOASTS_HIDE_SUCCESS_TOAST = 'TOASTS_HIDE_SUCCESS_TOAST';
export const TOASTS_SHOW_SUCCESS_TOAST = 'TOASTS_SHOW_SUCCESS_TOAST';

export const GANTT_GET_PEOPLE_GANTT_SHARE_DATA_SUCCESS_MESSAGE = 'Your filters and Gantt settings have been updated.';
export const GANTT_SET_PEOPLE_GANTT_SHARE_DATA_SUCCESS_MESSAGE = 'Link copied to clipboard';
